import Vue from 'vue';
export const defineState = (state, stateId, prop, val) => {
	Vue.set(state, stateId, state[stateId] || {});
	Vue.set(state[stateId], prop, val);
}
